// extracted by mini-css-extract-plugin
module.exports = {"socials-col":"Socials_socials-col__Y1Sz2","socials":"Socials_socials__g1jWB","flow-wrap":"Socials_flow-wrap__VTsPc","social":"Socials_social__cVf7N"};